import gql from "graphql-tag";
const popMessage = gql(` 
mutation popMessage($user: String!, $timestamp: Long!) {
  popMessage(user: $user, timestamp: $timestamp) {
  message
  }
}
`)
export default popMessage;
